import type { Locale } from "../localization/constants";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";

export type PanelAccessDenialReason = "provisioning" | "event_access";

export const getEventManagerAccessDeniedMessage = (
  locale: Locale = getAdminUiLocale()
) => getAdminT(locale)("eventAccess.managerDenied");

export const getEventAccessDeniedTitle = (
  locale: Locale = getAdminUiLocale()
) => getAdminT(locale)("eventAccess.accessDeniedTitle");

export const getEventProvisioningDeniedTitle = (
  locale: Locale = getAdminUiLocale()
) => getAdminT(locale)("eventAccess.provisioningDeniedTitle");

export const getPanelAccessBackLabel = (
  locale: Locale = getAdminUiLocale()
) => getAdminT(locale)("eventAccess.backToAccount");
